'use es6';

import PropTypes from 'prop-types';
export const alignPropType = PropTypes.oneOf(['left', 'right']);
export const sortPropType = PropTypes.oneOf(['ascending', 'descending', 'none']);
export const preferredSortPropType = PropTypes.oneOf(['ascending', 'descending']);